export default "__VITE_ASSET__C9tS4cUH__"